// extracted by mini-css-extract-plugin
export var linkText = "_o2-0";